
<template>
  <naj-box :title="locales.sectionTitle">
    <v-row>
      <v-col cols="6">
        <naj-input
          :type-id="formFieldType.radioButton"
          :value.sync="formModel.isNotifiedBeforeToBeDoRight"
          :label="locales.isNotifiedBeforeToBeDoRight"
          :items="yesNoOption"
          validates="required"
          item-value="id"
          item-text="name"
          :disabled="viewMode"
          @change="changeRequest"
        ></naj-input>
      </v-col>
      <v-col
        v-if="formModel.isNotifiedBeforeToBeDoRight == yesOrNoEnum.yes"
        cols="6"
      >
        <naj-input
          :type-id="formFieldType.radioButton"
          :value.sync="formModel.judicialInformingApproach"
          :label="locales.judicialInformingApproach"
          :items="judicialApproachOption"
          validates="required"
          item-value="id"
          item-text="name"
          :disabled="viewMode"
          @change="changeJudicialInformingApproach"
        ></naj-input>
      </v-col>
    </v-row>
    <v-row v-if="formModel.judicialInformingApproach == judicialInformingApproachEnum.other && formModel.isNotifiedBeforeToBeDoRight == yesOrNoEnum.yes">
      <v-col cols="6">
        <naj-input
          :type-id="formFieldType.multipleSelectBox"
          :label="locales.casePartyStatus"
          :value.sync="formModel.casePartyStatus"
          :items="casePartyStatus"
          item-value="id"
          item-text="name"
          :disabled="viewMode"
          :validates="`${formModel.judicialInformingApproach == judicialInformingApproachEnum.other ? 'required' : ''}`"
        ></naj-input>
      </v-col>
      <v-col cols="6">
        <naj-input
          :type-id="formFieldType.selectbox"
          :label="locales.isDefendantInformingWithJudicialInforming"
          :value.sync="formModel.isDefendantInformingWithJudicialInforming"
          :items="defendantInformingWithJudicialInformingOptions"
          item-value="id"
          item-text="name"
          :disabled="viewMode"
          :validates="`${formModel.judicialInformingApproach == judicialInformingApproachEnum.other ? 'required' : ''}|isValid: ${locales.invalidJudicialInformingDate}, ${!(formModel.judicialInformingApproach==judicialInformingApproachEnum.other && formModel.isDefendantInformingWithJudicialInforming==2)}`"
          @change="changeDefendantInformingWithJudicialInforming"
        ></naj-input>
      </v-col>
    </v-row>
    <v-row v-if="formModel.judicialInformingApproach == judicialInformingApproachEnum.other && formModel.isNotifiedBeforeToBeDoRight == yesOrNoEnum.yes">
      <v-col
        v-if="formModel.isDefendantInformingWithJudicialInforming==1"
        cols="12"
      >
        <naj-input
          :type-id="formFieldType.date"
          :label="locales.judicialInformingDefendantArrivalDate"
          :value.sync="formModel.judicialInformingDefendantArrivalDate"
          :disabled="viewMode"
          :validates="`${formModel.judicialInformingApproach == judicialInformingApproachEnum.other ? 'required' : ''}`"
        ></naj-input>
      </v-col>
    </v-row>
    <v-row>
      <v-col
        v-if="formModel.judicialInformingApproach == judicialInformingApproachEnum.forensicReportingPlatform
          && formModel.isNotifiedBeforeToBeDoRight == yesOrNoEnum.yes
        "
        cols="4"
      >
        <naj-input
          :type-id="formFieldType.text"
          :value.sync="formModel.requestCode"
          :label="locales.requestCode"
          :validates="validationRequestCode"
          :disabled="viewMode"
          @input="changeRequestCode"
        ></naj-input>
      </v-col>
      <v-col
        v-if="formModel.judicialInformingApproach == judicialInformingApproachEnum.forensicReportingPlatform
          && formModel.isNotifiedBeforeToBeDoRight == yesOrNoEnum.yes
        "
        cols="4"
      >
        <naj-input
          :type-id="formFieldType.selectbox"
          :label="locales.prosecutorsMenu"
          :value.sync="formModel.identityNumber"
          :items="prosecutors"
          :validates="`${formModel.judicialInformingApproach == judicialInformingApproachEnum.forensicReportingPlatform ? 'required' : ''}`"
          item-value="identityNumber"
          item-text="name"
          :disabled="viewMode"
          @change="changeIdentityNumber"
        ></naj-input>
      </v-col>
      <v-col
        v-if="!formModel.isJudicialInformingDocumentRetrieved
          && (formModel.judicialInformingApproach == judicialInformingApproachEnum.forensicReportingPlatform
            && formModel.isNotifiedBeforeToBeDoRight == yesOrNoEnum.yes
          )"
        cols="3"
        align-self="center"
        class="text-right"
      >
        <naj-button
          square
          :loading="isBtnChecking"
          :disabled="isCheckBtnDisabled"
          @click="check(false)"
        >
          {{ local.personInformation.check }}
        </naj-button>
      </v-col>
      <v-col
        v-if="formModel.isJudicialInformingDocumentRetrieved && (formModel.judicialInformingApproach == judicialInformingApproachEnum.forensicReportingPlatform
          && formModel.isNotifiedBeforeToBeDoRight == yesOrNoEnum.yes
        )"
        cols="3"
      >
        <naj-error-text
          :text="formModel.confirmationTxt"
          size="medium"
          no-margin
        ></naj-error-text>
      </v-col>
    </v-row>
    </v-row>
  </naj-box>
</template>
<script>
import { createNamespacedHelpers } from 'vuex';
const { mapActions, mapState } = createNamespacedHelpers('LawsuitModule');
const { mapState: mapLUTState } = createNamespacedHelpers('LookupsModule');
const { mapActions: mapGlobalActions } = createNamespacedHelpers('GlobalModule');
import { attachmentCategory, yesOrNoEnum, judicialInformingApproachEnum, attachmentType } from '@/helpers/enum.js';

export default {
  inject: ['$validator'],
  name: 'JudicialInforming',
  props: {
    validates: {
      type: Object,
      default: () => ({}),
    },
    requiredData: {
      type: Object,
      default: () => ({}),
      required: false,
    },
    formModel: {
      type: Object,
      required: true,
    },
    viewMode: {
      type: Boolean,
      required: false,
    },
    label: {
      type: String,
      required: false,
      default: '',
    },
  },
  data() {
    return {
      isBtnChecking: false,
      yesOrNoEnum,
      judicialInformingApproachEnum,
      judicialApproachOption: [
        {
          name: 'منصة التبليغ العدلي',
          id: judicialInformingApproachEnum.forensicReportingPlatform,
        },
        {
          name: 'غير ذلك',
          id: judicialInformingApproachEnum.other,
        },
      ],
      casePartyStatus: [
        {
          name: 'أحد طرفي الدعوى جهة إدارية',
          id: 1,
        },
        {
          name: 'أطراف الدعوى زوجين , أو تربطهم صلة قرابة إلي الدرجة الرابعة  ',
          id: 2,
        }, {
          name: 'أطراف الدعوى أتفقوا علي اللجوء إلي المصالحة والوساطة والتسوية الودية قبل اللجوء إلي القضاء',
          id: 3,
        }, {
          name: 'أطراف الدعوى لا تنطبق عليهم أي من الحالات السابقة',
          id: 4,
        },
      ],
      defendantInformingWithJudicialInformingOptions: [
        {
          name: 'نعم ومضى علي تسليم الإخطار إلي المدعى عليه أكثر من 15 يوم أو أكثر',
          id: 1,
        },
        {
          name: 'نعم ولم يمضى علي تسليم الإخطار إلى المدعي عليه 15 يوم',
          id: 2,
        },
      ],
    };
  },
  computed: {
    ...mapState({
      attachmentsData: state => state.attachments.data,
      lawsuitRequestAttachments: state => state.lawsuitRequest.requestAttachments,
    }),
    ...mapLUTState(['yesNoOption']),
    locales() {
      return this.local.dynamicFormAdmin.customComponents.judicialInformingDetails;
    },
    prosecutors() {
      const resultArray = this.requiredData.prosecutors.map(prosecutor => ({
        name: prosecutor.name,
        identityNumber: prosecutor.id.id,
        identityType: prosecutor.id.type,
      }));
      return resultArray;
    },
    isCheckBtnDisabled() {
      return ((!(this.formModel.isNotifiedBeforeToBeDoRight && this.formModel.requestCode && this.formModel.identityNumber) ||
        this.isBtnChecking));
    },
    validationRequestCode() {
      return {
        numeric: true,
        required: this.formModel.judicialInformingApproach == judicialInformingApproachEnum.forensicReportingPlatform,
        isVerified: this.formModel.isVerified,
        ...this.validates,
      };
    },
  },
  watch: {
    'formModel.isNotifiedBeforeToBeDoRight'(newVal, oldVal) {
      if (newVal != oldVal)
        this.$set(this.formModel, 'isJudicialInformingDocumentRetrieved', false);
    },
  },
  created() {
    if (this.formModel.requestCode && this.formModel.identityNumber)
      this.check(true);
  },
  methods: {
    ...mapActions(['verifyJudicialInformingDecision', 'deleteAttachment', 'handleDeleteAttachmentsByCategory']),
    ...mapGlobalActions(['handleAttachments']),
    resetForm() {
      this.$set(this.formModel, 'requestCode', null);
      this.$set(this.formModel, 'identityNumber', null);
      this.$set(this.formModel, 'confirmationTxt', null);
      this.$set(this.formModel, 'casePartyStatus', null);
      this.$set(this.formModel, 'isDefendantInformingWithJudicialInforming', null);
      this.$set(this.formModel, 'judicialInformingDefendantArrivalDate', null);
      this.$set(this.formModel, 'judicialInformingApproach', null);
    },
    removeAttachment() {
      const filteredFiles = Object.values(this.attachmentsData)
        .filter(c => c.category === attachmentCategory.informingDecisionAttachment && c.isAttachmentAudited);
      const filteredLawsuitRequestAttachments = Object.values(this.lawsuitRequestAttachments)
        .filter(c => c.fileCategory === attachmentCategory.informingDecisionAttachment && c.isAttachmentAudited);
      if ((filteredLawsuitRequestAttachments || []).length > 0) {
        this.handleDeleteAttachmentsByCategory(attachmentCategory.informingDecisionAttachment);
      }
      if (filteredFiles && filteredFiles.length > 0) {
        filteredFiles.forEach((file) => {
          this.deleteAttachment({
            objectKey: file.objectKey,
            attachmentKey: file.objectKey,
          });
        });
      }
    },
    changeDefendantInformingWithJudicialInforming() {
      this.$set(this.formModel, 'judicialInformingDefendantArrivalDate', null);
    },
    changeRequest(value) {
      this.formModel.isJudicialInformingDocumentRetrieved = false;
      if (!value || value == yesOrNoEnum.no) {
        this.removeAttachment();
        this.$set(this.formModel, 'isVerified', false);
      }
      this.resetForm();
    },
    changeJudicialInformingApproach(value) {
      this.formModel.isJudicialInformingDocumentRetrieved = false;
      if (!value || value == judicialInformingApproachEnum.other) {
        this.removeAttachment();
        this.$set(this.formModel, 'isVerified', false);
      }
      this.$set(this.formModel, 'requestCode', null);
      this.$set(this.formModel, 'identityNumber', null);
      this.$set(this.formModel, 'confirmationTxt', null);
      this.$set(this.formModel, 'casePartyStatus', null);
      this.$set(this.formModel, 'isDefendantInformingWithJudicialInforming', null);
      this.$set(this.formModel, 'judicialInformingDefendantArrivalDate', null);
    },
    changeRequestCode(value) {
      if (!value) {
        this.$set(this.formModel, 'identityNumber', null);
        this.$set(this.formModel, 'confirmationTxt', null);
      } else {
        this.$set(this.formModel, 'isJudicialInformingDocumentRetrieved', false);
        this.$set(this.formModel, 'judicialInformingApproach', judicialInformingApproachEnum.forensicReportingPlatform);
        this.$set(this.formModel, 'isNotifiedBeforeToBeDoRight', yesOrNoEnum.yes);
      }
    },
    changeIdentityNumber(value) {
      if (!value) {
        this.$set(this.formModel, 'requestCode', null);
        this.$set(this.formModel, 'confirmationTxt', null);
        this.$set(this.formModel, 'isJudicialInformingDocumentRetrieved', false);
      }
    },
    check(isLoadingPage) {
      this.$nextTick(() => {
        this.isBtnChecking = true;
        if (this.formModel.identityNumber)
          this.formModel.identityType = this.prosecutors.find(x => x.identityNumber == this.formModel.identityNumber).identityType;
        this.$set(this.formModel, 'isJudicialInformingDocumentRetrieved', false);
        this.verifyJudicialInformingDecision(this.formModel)
          .then((response) => {
            if (response.res.data.data.requestNotifyStatus) {
              const requestDate = new Date(response.res.data.data.creationDate);
              const currentDate = new Date();
              const timeDifference = currentDate.getTime() - requestDate.getTime();
              const dayDifference = Math.ceil(timeDifference / (1000 * 3600 * 24));
              if (dayDifference < 15) {
                this.toaster.error(this.locales.invalidJudicialInformingDate);
                this.$set(this.formModel, 'confirmationTxt', this.locales.invalidJudicialInformingDate);
                this.$set(this.formModel, 'isVerified', false);
              } else {
                this.prepareAndSaveRequestCertificateAttachment(response.res.data.data);
                if (!isLoadingPage)
                  this.toaster.success(this.locales.uploadSuccess);
                this.$set(this.formModel, 'confirmationTxt', this.locales.informStatusSuccess);
                this.$set(this.formModel, 'isVerified', true);
              }
            }
            else {
              this.toaster.error(this.locales.verificationFailed);
              this.$set(this.formModel, 'confirmationTxt', this.locales.verificationFailed);
              this.$set(this.formModel, 'isVerified', false);
            }
            this.$set(this.formModel, 'isJudicialInformingDocumentRetrieved', true);
          })
          .catch((err) => {
            this.toaster.error(this.locales.invalidData);
            this.$set(this.formModel, 'isVerified', false);
            this.$set(this.formModel, 'isJudicialInformingDocumentRetrieved', false);
          })
          .finally(() => {
            this.isBtnChecking = false;
          });
      });
    },
    prepareAndSaveRequestCertificateAttachment(data) {
      const name = (data || {}).fileName ? data.fileName :
        this.local.dynamicFormAdmin.customComponents.judicialInformingDetails.categoryName;
      const category = 1681;
      const content = data.requestCertificate?.split(',')[1];
      const extension = '.' + data.requestCertificate?.split(';base64,')[0].split('/')[1];
      const fileType = extension === '.pdf' ? attachmentType.pdf : attachmentType.image;
      let attachment = {
        fileName: name,
        fileType,
        content: content,
        fileCategory: category,
        extension,
        isAttachmentAudited: true,
      };
      return this.handleAttachments({
        attachments: [attachment],
        fileCategory: attachment.fileCategory,
      });
    },
  },
};
</script>

<style lang="scss" scoped>
</style>
